import React from "react";
import StaticPostLayout from "../components/StaticPostLayout";
import MapBlueRidgeParkway from "../components/Maps/blue-ridge-parkway";
import BlueRidgeParkwayInfo from "../components/TripInfo/blue-ridge-parkway";

class BlueRidgeParkway extends React.Component {
  render() {
    return (
      <StaticPostLayout
        title="Blue Ridge Parkway: 5-Day Road Trip Itinerary"
        category="Road Trips"
        slug="blue-ridge-parkway-itinerary"
        excerpt="America's longest linear national park — 469 miles of scenic Appalachian highway from Shenandoah to Great Smoky Mountains, with no trucks, no billboards, no rush."
        tags={["Road Trips", "Scenic Drives", "East Coast", "Appalachian", "Fall Foliage"]}
        readTime="9 min read"
        mapComponent={<MapBlueRidgeParkway />}
        whereToStay={[
          { name: 'Hotels in Asheville', type: 'Southern Hub · Asheville, NC', url: 'https://www.booking.com/searchresults.html?ss=Asheville%2C+North+Carolina' },
          { name: 'Big Meadows Lodge', type: 'NPS Lodge · Shenandoah, VA', url: 'https://www.booking.com/searchresults.html?ss=Luray%2C+Virginia' },
          { name: 'Hotels in Roanoke', type: 'Central Stop · Roanoke, VA', url: 'https://www.booking.com/searchresults.html?ss=Roanoke%2C+Virginia' },
        ]}
      >
        <BlueRidgeParkwayInfo />
      </StaticPostLayout>
    );
  }
}

export default BlueRidgeParkway;
